import { useTranslation } from 'react-i18next';
import { Dialog } from '../dialog/components/Dialog';
import { Text } from '../text';
import type { LeaveAlertOption } from './types';

type LeaveAlertDialogProps = {
  /** ダイアログの開閉状態 */
  isOpen: boolean;
  /** 確認ボタン押下時のコールバック */
  onConfirm: () => void;
  /** キャンセルボタン押下時のコールバック */
  onCancel: () => void;
  /** アラートダイアログのオプション */
  options?: LeaveAlertOption | undefined;
};

/**
 * 離脱確認ダイアログの共通コンポーネント
 *
 * LeavePageAlert と SidePanelLeaveAlert で共通利用される
 * ダイアログ表示部分を抽出したコンポーネント
 */
export const LeaveAlertDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  options,
}: LeaveAlertDialogProps) => {
  const { t } = useTranslation();

  const {
    title = t('panel-leave-alert.title'),
    description = t('panel-leave-alert.description'),
    cancelLabel = t('common.actions.cancel'),
    confirmLabel = t('panel-leave-alert.confirm'),
  } = options ?? {};

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
      onConfirm={onConfirm}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      title={title}
      confirmVariant="default"
      width="s"
    >
      <Text variant="body" className="whitespace-pre-line">
        {description}
      </Text>
    </Dialog>
  );
};
